module.exports = __webpack_public_path__ + "static/media/Sebastian.6abeb74a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Sebastian.png
// module id = 1434
// module chunks = 0